import React from 'react'
import './cv.scss';

import { ImAttachment } from 'react-icons/im';
import { MdEmail } from 'react-icons/md';
import { FaPhone } from 'react-icons/fa';
import { SiLinkedin } from 'react-icons/si';


const CV = () => {
    return (
        <div className="CV-body">
            <article className="container">
                <div className="row">

                    <div className="py-3 my-5 col-xs-12 col-md-8">
                        <h2 className="headline p-2">Personprofil</h2>
                        <p className="pl-3">Jeg er 37 år gammel og er i god fysisk form. Jeg går op i at leve sundt og jeg ryger ikke. Som person er jeg meget åben og jeg anser
                        jeg mig selv for at være ansvarlig, ambitiøs, lærenem, hjælpsom, tålmodig og nem at omgås. Jeg er god til at holde overblikket og er
                        ligeledes meget selvstændig. Jeg har altid haft en evne til at kommunikere med- og tilpasse mig andre mennesker ligegyldig køn, alder
                        og baggrund. Jeg er også god til at formidle min viden videre til andre, på sådan en måde, så det er nemt forståeligt og tilpasset til
                        hver enkelt persons individuelle niveau. Jeg har typisk en smittende gejst, er positiv og i godt humør.</p>

                        <h2 className="my-3 p-2 mt-5 headline">Uddannelse</h2>
                        <h4 className="pl-3">Webudvikler</h4>
                        <p className="pl-4">VidenDjurs, Grenaa - Januar 2020 - Maj 2021</p>
                        <p className="pl-4">Fik merit for grundforløb. Afsluttende karakter: 12</p>

                        <h4 className="pl-3">Lærer</h4>
                        <p className="pl-4">VIA University College, Århus, 2013-2015</p>
                        <p className="pl-4">Læste engelsk, matematik og idræt - udover de obligatoriske pædagogiske fag.</p>

                        <h4 className="pl-3">Højere Forberedelseseksamen (HF)</h4>
                        <p className="pl-4">VUC Hornslet, 2010-2012</p>
                        <p className="pl-4">Fik karakteren 12 i samtlige 17 eksamener (se bilag)</p>


                        <h2 className="my-3 p-2 mt-5 headline">Erhvervserfaring</h2>
                    
                        <h4 className="pl-3">Erhvervsskolelærer (Vikar)</h4>
                        <p className="pl-4">Viden Djurs - Webit Grenaa, 2021 - 2022</p>
                        <p className="pl-4">Har undervist i bl.a.: HTML, CSS, Programmering (JS), React, CMS (WordPress). Har også haft ansvar for undervisning af brobygningselever samt udvikling af nye opgaver og materiale dertil.</p>

                        <h4 className="pl-3">Tekniker</h4>
                        <p className="pl-4">Refurb - Genbrugt IT, Hornslet, 2018 - 2020</p>
                        <p className="pl-4">Refurbishment af telefoner (Android og iOS), laptops og stationære computere med henblik på gensalg. Reperation/Udskiftning af hardware, samt genopsætning af software</p>

                        <h4 className="pl-3">Produktionsmedarbejder</h4>
                        <p className="pl-4">Carletti - Skødstrup, 2015 - 2018</p>
                        <p className="pl-4">Indstilling og betjening af produktionsmaskiner i eget IT-system. Truck-kørsel og lagerarbejde.</p>

                        <h2 className="my-3 p-2 mt-5 headline">IT-kompetencer</h2>
                        <p className="pl-4">
                            Webudvikler: VS Code, HTML 5, CSS, SASS, Javascript, React, Bootstrap, Wordpress, Strapi
                        </p>
                        <p className="pl-4">
                            Selvlært IT-nørd gennem 25 år:
                            Grafik/billedbehandling: Photoshop. Videoredigering: Sony Vegas, Camtasia Studio. Windows+Office-pakken: Superbruger. Hardware: udskiftning/opgradering/fejlfinding og samle PC fra bunden af. Support: TeamViewer.
                        </p>

                        <h2 className="my-3 p-2 mt-5 headline">Fritid</h2>
                        <p className="pl-4">
                            Generelt har jeg en meget bred smag og mange forskellige interesser, men jeg har altid været lidt af en ’nørd’, hvor min primære interesse ligger
                        indenfor science fiction og fantasy. Det gælder både når det kommer til film, tv og bøger, men computerspil og software har altid fyldt mest. <br /><br />

                        Dog har jeg også altid været meget fysisk aktiv. Dette er bl.a. kommet til udtryk i mit valg af 10.klasse idrætslinjen, mange års mountainbiking, taekwondo og senest styrketræning, som jeg har dyrket i 8 år nu. <br /><br />

                        Størstedelen af min fritid prioriterer jeg at bruge sammen med min kone, hvor vi har en fælles interesse i gaming, tv-serier og film. Når der er tid
                        og råd til det, elsker vi at rejse ud og se verden sammen. Senest har vi været i London, hvor vi bl.a. var på den fantastiske Harry Potter Studio Tours.
                        </p>

                    </div>

                    <div className="py-3 my-5 col-xs-12 col-md-4 contactinfo">

                        <h3 className="headline2 p-2">Bilag</h3>
                        <p className="dl-link pl-3">
                            <ImAttachment />  <a href="/Eksamensbevis1.pdf" download target="_blank" rel="noopener noreferrer"> Eksamensbevis1.pdf  </a>
                        </p>
                        <p className="dl-link pl-3">
                            <ImAttachment /> <a href="/Eksamensbevis2.pdf" download target="_blank" rel="noopener noreferrer"> Eksamensbevis2.pdf  </a>
                        </p>
                        <p className="dl-link pl-3">
                            <ImAttachment /> <a href="/Eksamensbevis3.pdf" download target="_blank" rel="noopener noreferrer"> Eksamensbevis3.pdf  </a>
                        </p>


                        <h3 className="headline2 p-2">Kontakt</h3>
                        <p className="pl-3"> <MdEmail /> kennethhs1985@gmail.com</p>
                        <p className="pl-3"> <FaPhone /> 61 68 73 56</p>
                        <p className="pl-3"> <SiLinkedin/> <a href="http://www.linkedin.com/in/kenneth-sørensen-33a60a206/" target="_blank" rel="noopener noreferrer"> Kenneth Sørensen </a> </p>


                    </div>

                </div>

            </article>
        </div>
    )
}

export default CV

